import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { useCallback, useEffect, useState } from 'react';
import { createStructuredSelector } from 'reselect';
import {
    getPasswordMinLengthSelector,
    makeSelectAppFormError,
    makeSelectAppLoggedIn,
} from '../../../app/appSelectors';
import { connect } from 'react-redux';
import { logAppsflyerAction, resetFormErrorAction } from '../../../app/appActions';
import { useInitialUrlSearchParams } from '../../../hooks/useInitialUrlSearchParams';
import { REGISTRATION_URL_INITIAL_PARAMS } from './mobileAppRegistrationConstants';
import { usePasswordTooltip } from '../../../components/PasswordTooltip/passwordTooltipHooks';
import { Redirect } from 'react-router-dom';
import { MobileRouterPaths } from '../../mobileAppConstants';
import { registrationPrepareMobileAction } from '../../mobileAppActions';
import { useLocation } from 'react-router';
import axios from 'axios';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { LOG_AF_EVENT_NAMES } from '../../../app/appConstants';
import { useLocationProviderContext } from '../../../providers/LocationProvider/LocationProviderContext';
import { REGISTRATION_FIELDS_ERRORS } from '../../../modules/Login/components/registrationConstants';
import { useFormFieldErrors } from '../../../hooks/useFormFieldErrors';
import appHistory from '../../../app/appHistory';

function MobileAppRegistration(props) {
    const {
        formError,
        isLoggedIn,
        logAppsflyer,
        passwordMinLength,
        registrationPrepare,
        resetFormError,
    } = props;

    const location = useLocation();
    const { prevLocation } = useLocationProviderContext();
    const { getLangPath } = useLangContext();

    const { email: initialEmail } = useInitialUrlSearchParams(REGISTRATION_URL_INITIAL_PARAMS);
    const { acceptPolicy: acceptPolicyError, email: emailError, password: passwordError, common: commonError } =
        useFormFieldErrors(REGISTRATION_FIELDS_ERRORS, formError);
    const [selectedIso, setSelectedIso] = useState(null);

    const {
        isShowPasswordTooltip, checkPasswordValue, onBlurPasswordField, onSelectPasswordField, onChangePasswordField,
    } = usePasswordTooltip();

    useEffectOnce(() => {
        logAppsflyer({
            name: LOG_AF_EVENT_NAMES.SIGN_UP_SHOWN,
            payload: { source: prevLocation.pathname || 'None' },
        });
    });

    useEffect(() => {
        axios.get('https://api.country.is/')
            .then(geo => {
                setSelectedIso(geo.data?.country);
            })
            .catch(() => {
                // nothing
            });
    }, []);

    const handleChange = useCallback((isValid) => {
        if (!isValid) {
            resetFormError();
        }
    }, [resetFormError]);

    const handlePasswordChange = useCallback((e) => {
        handleChange(!passwordError);
        onChangePasswordField(e);
    }, [handleChange, onChangePasswordField, passwordError]);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        logAppsflyer({ name: LOG_AF_EVENT_NAMES.SIGN_UP_STARTED });
        registrationPrepare({
            acceptRules: e.target.querySelector('[name=accept-rules]').checked,
            email: e.target.querySelector('[name=email]').value,
            phone: e.target.querySelector('[name=phone]')?.value,
            country: selectedIso?.toLowerCase() || null,
            password: e.target.querySelector('[name=password]')?.value,
        });
    }, [registrationPrepare, selectedIso, logAppsflyer]);

    const handleOpenLogin = useCallback(() => {
        const email = document.querySelector('[name=email]').value;
        appHistory.push(`${MobileRouterPaths.login}?email=${email}`);
    }, []);

    const handleAlreadyHasAccountClick = useCallback(() => {
        logAppsflyer({ name: LOG_AF_EVENT_NAMES.SIGN_UP_ALREADY_HAVE_ACCOUNT });
        handleOpenLogin();
    }, [handleOpenLogin, logAppsflyer]);

    if (isLoggedIn) {
        return <Redirect to={{
            pathname: location.state?.originPathname || MobileRouterPaths.default,
            search: location.state?.originSearch,
        }} />;
    }

    return <Redirect to={MobileRouterPaths.login} />;

    // return <div className="d-flex justify-content-center align-items-center h-100">
    //     <Form onSubmit={handleSubmit}>
    //         <MobileAppRegistrationContentStyled>
    //             <h1 className="text-center">{getLangPath('sign_up.title')}</h1>
    //             <Form.Control defaultValue={initialEmail} name="email" type="email" className="mt-3"
    //                           placeholder={getLangPath('sign_up.enter_email')}
    //                           isInvalid={!!emailError} onChange={() => handleChange(!emailError)}/>
    //             {
    //                 !!emailError && <>
    //                     <Form.Control.Feedback type="invalid">
    //                         {getLangPath(emailError)}
    //                         {formError === 'error.already_registered' && (
    //                             <>.&nbsp;<u onClick={handleOpenLogin}>{getLangPath('promo.fx.log_in')}</u></>
    //                         )}
    //                     </Form.Control.Feedback>
    //                 </>
    //             }
    //
    //             <PasswordTooltip password={checkPasswordValue} show={isShowPasswordTooltip}>
    //                 <Form.Group className="mt-3">
    //                     <FormPasswordEye
    //                         name="password"
    //                         placeholder={getLangPath('sign_up.create_password')}
    //                         isInvalid={!!passwordError}
    //                         iconColor="var(--color-secondary)"
    //                         onSelect={onSelectPasswordField}
    //                         onBlur={onBlurPasswordField}
    //                         onChange={handlePasswordChange}
    //                     />
    //                     {
    //                         !!(passwordError) && (
    //                             <Form.Control.Feedback type="invalid">
    //                                 {getLangPath(formError, {count: passwordMinLength})}
    //                             </Form.Control.Feedback>
    //                         )
    //                     }
    //                 </Form.Group>
    //             </PasswordTooltip>
    //             {
    //                 !!commonError && (
    //                     <Form.Control.Feedback type="invalid" className="d-block mt-3">
    //                         {getLangPath(commonError)}
    //                     </Form.Control.Feedback>
    //                 )
    //             }
    //
    //             <RegistrationAcceptPolicy className="mt-2rem" error={acceptPolicyError} onChange={() => handleChange(!acceptPolicyError)}/>
    //
    //             <Button variant="primary" size="lg" type="submit" className="mt-2rem">
    //                 {getLangPath('sign_up.title')}
    //             </Button>
    //             <Button variant="outline-info" size="md" onClick={handleAlreadyHasAccountClick} type="button"
    //                     className="mt-3">
    //                 {getLangPath('sign_up.have_account')}
    //             </Button>
    //         </MobileAppRegistrationContentStyled>
    //     </Form>
    // </div>
}

const mapStateToProps = createStructuredSelector({
    isLoggedIn: makeSelectAppLoggedIn(),
    formError: makeSelectAppFormError(),
    passwordMinLength: getPasswordMinLengthSelector,
});

const mapDispatchToProps = (dispatch) => ({
    logAppsflyer: payload => dispatch(logAppsflyerAction(payload)),
    registrationPrepare: (payload) => dispatch(registrationPrepareMobileAction(payload)),
    resetFormError: (payload) => dispatch(resetFormErrorAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppRegistration);
